const code = {
  title: 'Verification code',
  codeLabel: 'Verification code',
  confirmButtonText: 'Verify',
  cancelButtonText: 'Restart set-up process',
  instructions: {
    title: 'I did not receive a code',
    instruction1: 'Please wait a few minutes',
    instruction2: 'Try to resend the verification code',
    instruction3: 'Contact Customer Service',
  },
  messages: {
    codeFormat: 'The verification code only contains numbers',
    invalidCode: 'Invalid verification code.',
    formError: 'We found some errors. Please review the form and make corrections.',
    formAttemptsError: 'You have exceeded the maximum number of attempts to enter a verification code. For security reasons, please contact our <1>Customer Service at 1-888-610-5101</1> for assistance or <3>request a new code.</3>',
  },
};

export default {
  title: 'Multi-factor Authentication',
  steps: {
    password: {
      title: 'Multi-factor Authentication',
      info: 'Multifactor authentication is a two-step validation process that requires you to provide two types of information to confirm your identity in order to log in. To change your authentication factors and set up new ones, please enter your password.',
      factorTitle: 'Factor(s) set up',
      passwordLabel: 'Password',
      confirmButtonText: 'Continue',
      messages: {
        ...code.messages,
      },
    },
    informations: {
      title: 'Multi-factor Authentication',
      info: '<p>Please confirm your information to set up your authentication factors and strengthen the security of your login.</p><p>This information will only be used to set up your authentication factors; your client profile will not be updated.</p>',
      emailLabel: 'Email',
      phoneLabel: 'Phone number',
      confirmButtonText: 'Confirm',
    },
    email: {
      ...code,
      info: 'A verification code will be sent to you to validate your email address.',
      description: 'Send a code by email to {{information}}',
      confirmButtonText: 'Receive a code by email',
    },
    emailCode: {
      ...code,
      info: 'Please enter the verification code we sent to your email address {{information}}',
    },
    phone: {
      ...code,
      info: 'A verification code will be sent to you to validate your phone number, {{information}}',
      methodLabel: 'How do you want to receive the verification code?',
      smsMethodLabel: 'By text message',
      callMethodLabel: 'By voice call',
      methods: {
        sms: {
          confirmButtonText: 'Receive a code by text message',
        },
        voice: {
          confirmButtonText: 'Receive a code by voice call',
        },
      },
    },
    phoneCode: {
      ...code,
      info: 'Please enter the verification code that we sent by {{method}} to {{information}}',
      methods: {
        sms: {
          name: 'text message',
        },
        voice: {
          name: 'voice call',
        },
      },
    },
    confirmation: {
      title: 'Thank you!',
      description: 'Your authentication factors are currently being configured. The next time you log in, you will be asked to provide a one-time verification code to confirm your identity.',
      confirmButtonText: 'Go to My Client Space',
    },
  },
};
